module.exports = __webpack_public_path__ + "_2C71P0Ce7JeAJ9Ta/tandc_icon.svg";